// src/components/GlobalStyles.js
import { Global, css } from '@emotion/react';

const GlobalStyles = () => (
  <Global
    styles={css`
      * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
      }

      body {
        margin: 0;
        padding: 0;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
          Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        background-color: ${props => props.theme.colors.background};
      }

      #root {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
      }
    `}
  />
);

export default GlobalStyles;